import { dbService } from './db';
import { Form, Link, useSubmit, useLoaderData } from "react-router";
import React, { useRef, useState, useEffect } from 'react';

export function meta({ }) {
  return [
    { title: "DX Sales App - Customer" },
    { name: "description", content: "Welcome to DX Sales App - Customer" },
  ];
}

export async function clientLoader({params}) {
  let db = await dbService.createDB();
  const index = db.transaction('customers').store.index('customerNumberIndex');
  let customer = await index.get(params.customerId)
  const salesIndex = db.transaction('sales').store.index('customerNumberIndex');
  let sales = (await salesIndex.getAll(params.customerId)).map((so: { salesId: any; }) => ({...so, key: so.salesId} ));
  return { customer, sales };
}

export function Customer({params, loaderData}) {
  const { customer, sales } = useLoaderData();
  
  return (
    <>
      <h1 className="text-xl text-red-800 text-center">{customer.name}</h1>
      <h1 className="text-l text-red-800 text-center">{customer.customerNumber} - {customer.lastOrderDate}</h1>
      <div>
        {sales && sales.map((x, i) =>
          <Link key={x.id} to={`/sales/${x.salesId}`} className="block bg-white p-2 outline-gray-800 m-2 border border-gray-800 rounded-sm">
            <span className="block p-0 m-0 text-gray-800">{x.salesId}</span> 
            <span className="text-xs italic font-semibold text-red-800">{x.status}</span> 
          </Link>
        )}
      </div>
    </>
  );
}